import { InputNumber } from "antd";
import React from "react";
import { toNumber } from "../../../../../../../service/service";
import { RuleCountData } from "../../../../../../../service/score";

interface CountFieldProps {
    value?: RuleCountData;
    onChange?(value?: RuleCountData): void;
}

export function CountField({ value, onChange }: CountFieldProps) {
    return (
        <div>
            <InputNumber
                min={0}
                precision={0}
                value={toNumber(value?.cnt)}
                onChange={cnt =>
                    onChange?.({
                        cnt: cnt || 0,
                        ruleModelName: value?.ruleModelName || ""
                    })
                }
            />{" "}
            次
        </div>
    );
}
